import React, { Component } from "react";
import { shuffle } from "./helpers";

class Variants extends Component {
  state = {
    question: null,
    selection: null
  };

  constructor(props) {
    super(props);
    const { question, onSelection } = props;
    question.variants = shuffle(question.variants);
    this.state.question = question;
    this.onSelection = onSelection;
  }

  setActiveVariant(variant) {
    this.setState({ selection: variant });
    this.onSelection(variant);
  }

  componentWillReceiveProps(props) {
    const { question, onSelection } = props;
    // shuffle only for the first time
    if (this.state.question.title !== question.title) {
      question.variants = shuffle(question.variants);
    }
    this.setState({ question });
    this.onSelection = onSelection;
  }

  render() {
    const { question } = this.state;
    if (!question) {
      return null;
    }
    return (
      <React.Fragment>
        <div className="level content">
          <div className="is-medium">
            <h2 className="level-item">{question.title}</h2>
          </div>
        </div>
        {question.variants.map((variant, i) => {
          return (
            <div className="level container" key={i}>
              <button
                className={[
                  "button is-fullwidth variantsButton",
                  JSON.stringify(this.state.selection) ===
                  JSON.stringify(variant)
                    ? "is-active"
                    : undefined
                ].join(" ")}
                onClick={() => this.setActiveVariant(variant)}
              >
                {variant.title}
              </button>
            </div>
          );
        })}
      </React.Fragment>
    );
  }
}

export default Variants;
